// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2S9Cp","right":"styles_right__2k_AS"};